import { Axios } from "../lib/axios";
export const MetricRulesServices = {
  toggleMetricRule,
};
function toggleMetricRule(metricRuleId, body) {
  return Axios.get(`metric-rules/${metricRuleId}/status/${body.is_active}`);
}
